interface ResultsPlaceholderProps {
    isClosed: boolean;
}

/** One block per question the placeholder draws: whether it has a rating scale under its title. */
const QUESTION_BLOCKS = [{ hasScale: true }, { hasScale: true }, { hasScale: false }];
/** The seven steps of a rating scale, a few of them tinted as answered ratings would be. */
const SCALE_STEPS = [
    'bg-white/70',
    'bg-error-25',
    'bg-white/70',
    'bg-warning-25',
    'bg-white/70',
    'bg-success-25',
    'bg-success-25',
];

/** The two comment lines under each question, of unequal length as written comments are. */
const COMMENT_WIDTHS = ['w-2/5', 'w-1/3'];

/**
 * The shape of the results to come, blurred behind the explanation of why they are withheld. Drawn from nothing
 * the feedback holds — no question, no rating, no comment — and hidden from assistive technology.
 */
export const ResultsPlaceholder = ({ isClosed }: ResultsPlaceholderProps) => (
    <div
        aria-hidden
        className={`absolute inset-0 flex flex-col gap-14 px-6 py-14 blur-xs md:px-28 ${
            isClosed ? 'opacity-40 grayscale' : 'opacity-70'
        }`}
        data-testid={'results-placeholder'}
    >
        {QUESTION_BLOCKS.map(({ hasScale }, index) => (
            <div
                key={index}
                className={'flex flex-col gap-3'}
            >
                <span className={'bg-base-200 h-3.5 w-3/5 rounded-full'} />

                <span className={'bg-base-100 h-2.5 w-1/4 rounded-full'} />

                {hasScale && (
                    <div className={'mt-3 grid h-16 grid-cols-7 overflow-hidden rounded-lg'}>
                        {SCALE_STEPS.map((tint, step) => (
                            <span
                                key={step}
                                className={tint}
                            />
                        ))}
                    </div>
                )}

                {COMMENT_WIDTHS.map((width) => (
                    <div
                        key={width}
                        className={'flex items-center gap-3 rounded-lg bg-white/70 px-4 py-3'}
                    >
                        <span className={'bg-base-100 h-7 w-7 rounded-full'} />

                        <span className={`bg-base-100 h-2.5 rounded-full ${width}`} />
                    </div>
                ))}
            </div>
        ))}
    </div>
);
